export default __webpack_public_path__ + "static/media/giphy.b97e3f28.gif";